import { useMutation } from "@apollo/client";

import { GqlSettingsResearchTypeSpeciesUpdateShowToClientUserInput } from "~/__generated__/graphql/types";

import { SettingsResearchTypeEditRoute_UpdateShowToClientUserDocument } from "../mutations.generated";
import { SettingsResearchTypeEditRoute_GetByIdDocument } from "../queries.generated";

export function useSettingsResearchTypeEditRoute_UpdateShowToClientUser() {
    const [mutate, { loading, error }] = useMutation(SettingsResearchTypeEditRoute_UpdateShowToClientUserDocument, {
        refetchQueries: [SettingsResearchTypeEditRoute_GetByIdDocument],
    });

    const updateSpeciesShowToClientUser = async (input: GqlSettingsResearchTypeSpeciesUpdateShowToClientUserInput) => {
        await mutate({ variables: { input } });
    };

    return {
        updateSpeciesShowToClientUser,
        loading,
        error,
    };
}
